<template>
  <div class="content flex my-4">
    <div class="auth-form mx-auto my-auto">
      <div class="card">
        <div class="card-body flex flex-column">
          <h1 class="heading-bigger mb-4 text-center">{{ $t('invitationConfirm.invitationConfirmation') }}</h1>

          <f-alert
            v-if="invitationError"
            class="my-2"
            theme="danger"
            centered
            visible>
            {{ $t('ui.errorOccurredTryAgain') }}
          </f-alert>

          <f-alert
            v-if="invitationSuccess"
            class="my-2"
            theme="success"
            centered
            visible>
            {{ $t('invitationConfirm.invitationAccept') }}
          </f-alert>

          <f-button
            v-if="!invitationSuccess"
            type="submit"
            theme="primary"
            class="full-width mt-1"
            big
            withArrow
            @click.prevent="confirmInvitation"
            :disabled="submitting">
            <template v-if="!submitting">{{ $t('invitationConfirm.confirmInvite') }}</template>
            <template v-else>{{ $t('invitationConfirm.invitationConfirmation') }}&hellip;</template>
          </f-button>

          <div class="text-center mt-4">
            <router-link
              to="/logowanie"
              class="lnk lnk-big lnk-big-blue"
              :disabled="submitting">
              {{ $t('ui.backToLoginPage') }}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'invitation-confirm',
  data () {
    return {
      invitationSuccess: false,
      invitationError: false,
      submitting: false
    }
  },
  mounted () {
  },
  methods: {
    confirmInvitation () {
      Vue.set(this, 'submitting', true);
      this.$http.post('/api/auth/confirm-invitation', this.$route.params).then(() => {
        Vue.set(this, 'submitting', false);
        this.invitationSuccess = true;
        this.invitationError = false;
      }).catch((error) => {
        Vue.set(this, 'submitting', false);
        this.invitationSuccess = false;
        this.invitationError = true;
        console.log(error);
      });
    }
  }
};
</script>
